<div *transloco="let t; prefix: 'scDeviceAuth'" class="sh-device-password-configuration-container">
	@if (options.keepExisting || options.dontSet || options.removeAll) {
		<prism-radio-group
			id="sh-device-password-configuration-mode-selection"
			[attr.aria-label]="t('common-device-password.radio-group-label')"
			class="sh-password-options-container"
			[disabled]="disabled"
			[value]="passwordOption.NewCommonPassword"
			(valueChange)="onOptionSelectionChange($event.detail)"
		>
			<prism-radio-button
				id="sh-device-password-configuration-button-new-common-password"
				checked
				[value]="passwordOption.NewCommonPassword"
			>
				<div class="sh-password-option-title">
					{{ t('common-device-password.options.set-common.title') }}
				</div>
				<div class="sh-password-option-description">
					{{
						descriptionSetCommonOption
							? descriptionSetCommonOption
							: t('common-device-password.options.set-common.description')
					}}
				</div>
			</prism-radio-button>
			@if (options.keepExisting) {
				<prism-radio-button
					id="sh-device-password-configuration-button-keep-existing"
					[value]="passwordOption.KeepExisting"
				>
					<div class="sh-password-option-title">
						{{ t('common-device-password.options.keep-existing.title') }}
					</div>
					<div class="sh-password-option-description">
						{{ t('common-device-password.options.keep-existing.description') }}
					</div>
				</prism-radio-button>
			}
			@if (options.dontSet) {
				<prism-radio-button
					id="sh-device-password-configuration-button-dont-set"
					data-testid="sh-device-password-configuration-button-dont-set"
					[value]="passwordOption.DontSetPassword"
				>
					<div class="sh-password-option-title">{{ t('common-device-password.options.dont-set.title') }}</div>
					<div class="sh-password-option-description">
						{{ t('common-device-password.options.dont-set.description') }}
					</div>
				</prism-radio-button>
			}
			@if (options.removeAll) {
				<prism-radio-button
					id="sh-device-password-configuration-button-remove-all"
					[value]="passwordOption.RemoveAll"
				>
					<div class="sh-password-option-title">
						{{ t('common-device-password.options.remove-all.title') }}
					</div>
					<div class="sh-password-option-description">
						{{ t('common-device-password.options.remove-all.description') }}
					</div>
				</prism-radio-button>
			}
		</prism-radio-group>
	}

	<div class="sh-passwords-container sh-password-options-container">
		<prism-input
			class="sh-password-field"
			data-testid="password-input"
			angular-input
			type="password"
			[formControl]="passwordFormGroup.controls.password"
			[isValid]="passwordFormGroup.controls.password.valid"
		>
			<span slot="label">{{ t('common-device-password.enter-new-password') }}</span>
			<span slot="help-text">{{ t('room-settings.device-passwords.password-hint') }}</span>
			@if (passwordFormGroup.controls.password.errors?.['required']) {
				<span slot="error-text">{{ t('common-device-password.errors.password-required') }}</span>
			}
			@if (passwordFormGroup.controls.password.errors?.['onlyWhiteSpace']) {
				<span slot="error-text">{{ t('common-device-password.errors.no-whitespace-only') }} </span>
			}
			@if (
				(passwordFormGroup.controls.password.errors?.['minlength'] ||
					passwordFormGroup.controls.password.errors?.['maxlength']) &&
				!passwordFormGroup.controls.password.errors?.['onlyWhiteSpace']
			) {
				<span slot="error-text">{{ t('common-device-password.errors.min-max-length') }} </span>
			}
		</prism-input>

		<prism-input
			class="sh-password-field"
			data-testid="confirm-password-input"
			angular-input
			type="password"
			[formControl]="passwordFormGroup.controls.confirmPassword"
			[isValid]="passwordFormGroup.controls.confirmPassword.valid"
			(keydown.Enter)="onEnter()"
		>
			<span slot="label">{{ t('common-device-password.confirm-new-password') }}</span>
			@if (passwordFormGroup.errors?.['mismatch']) {
				<span slot="error-text">{{ t('common.errors.passwords-dont-match') }}</span>
			}
		</prism-input>
	</div>
</div>
